import { MainNavigationProps } from '@wfp/ui';
import { useUserProfileDetails } from './UserProfileDetails.hooks';
import { UserProfileDetailsView } from './UserProfileDetailsView';

export const UserProfileDetails = (props: MainNavigationProps) => {
  const {
    userProfile,
    username,
    email,
    flaUserRoles,
    reportingUserRoles,
    logout
  } = useUserProfileDetails();

  return (
    <UserProfileDetailsView
      {...props}
      userProfile={userProfile}
      username={username}
      email={email}
      flaUserRoles={flaUserRoles}
      reportingUserRoles={reportingUserRoles}
      logout={logout}
    />
  );
};
